// src/Skeletons/POOverviewSkeleton.jsx
import React from 'react'
import { Box, Skeleton, Typography } from '@mui/material'
import PageContainer from '../components/common/PageContainer'

/**
 * POOverviewSkeleton — der Platzhalter der PO-Liste.
 *
 * 🔴 G0b.5 (2026-10-13), NW5.7:809: **jedes Skelett traegt das Muster seiner
 * Seite.** Der Platzhalter trug bis hierher einen nackten `<Container
 * maxWidth="lg">`, der per `MuiContainer`-Override auf 1440 gezogen wurde — und
 * **nach dem Umbau still auf 1200** (`lg`) gefallen waere, ohne dass ihn eine
 * Pruefung sieht (`inhaltsbreite.md` §5.3:723-724). Jetzt traegt er ein
 * ausdrueckliches Muster; **PW14** vergleicht Skelett und Seite (±1 px).
 *
 * 🔴 **Seit G2b (2026-10-16) traegt auch die Seite `full` — die Zeile ist
 * mitgezogen.** Die Vorfassung stand hier auf `reading` und begruendete es mit
 * einem gemessenen Zustand: *„`POOverview.jsx` rendert `<PageContainer
 * sx={{ pb: 6 }}>` **ohne** `width`, also die Vorgabe (1280)"* — das war richtig,
 * solange G0b.5 die Umstellung nicht mitnahm (ihr Umfang §3.3:695-701 nennt vier
 * nackte Container-Seiten, `/overview` **nicht**).
 *
 * Die G2-Karte hat diesen Vorbehalt ausdruecklich adressiert und die Zeile
 * angekuendigt: *„Wer `/overview` spaeter auf `full` stellt (seine Ansichtskarte),
 * zieht **diese Zeile im selben Commit** nach — dann sind beide wieder gleich."*
 * Genau das ist hier geschehen (G2b, `feat/ui2-t10-g2b-mobil-breiten`): die Seite
 * rendert `width="full"`, das Skelett zieht nach. **Die zwei Muster sind damit
 * wieder gleich** — und genau das misst **PW14** (`tests/listen/breite.spec.ts`,
 * Quelltext-Vergleich beider Dateien **und** gerenderte Blockbreite).
 */
const POOverviewSkeleton = () => (
  <PageContainer width="full" sx={{ mt: 2 }}>
    <Typography variant="h5" gutterBottom>
      <Skeleton width="30%" />
    </Typography>

    {/* Filter bar skeleton */}
    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
      <Skeleton variant="rectangular" width={120} height={40} />
      <Skeleton variant="rectangular" width={160} height={40} />
    </Box>

    {/* DataGrid header */}
    <Skeleton variant="rectangular" height={40} />

    {/* DataGrid rows */}
    {[...Array(6)].map((_, idx) => (
      <Skeleton
        key={idx}
        variant="rectangular"
        height={52}
        sx={{ mt: 1 }}
      />
    ))}
  </PageContainer>
)

export default POOverviewSkeleton
